import Store from "../../shared/functions/store";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
const key = "intros";
export const hasDoneTour = (name) => {
    const tours = Store.get(key) || {};
    return tours[name] || false;
};
export const markTourAsDone = (name) => {
    const tours = Store.get(key) || {};
    tours[name] = true;
    Store.set(key, tours);
};
export const markTourAsNotDone = (name) => {
    const tours = Store.get(key) || {};
    tours[name] = false;
    Store.set(key, tours);
};
export const Tourmanager = {
    Tour: driver,
    hasDoneTour,
    markTourAsDone,
    markTourAsNotDone,
};
export default Tourmanager;
